import { useState } from 'react';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import Background from '../../assets/img/background.png';
import logoTalent from '../../assets/logo/Frame 1870.png';

import PasswordForget from './PasswordForget';
import PasswordValidateCode from './PasswordValidateCode';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    backgroundImage: `url(${Background})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: '100vh',
    margin: 0,
    maxHeight: '100%',
    overflow: 'auto',
    width: '100vw',
    color: theme.palette.background.card,
  },
  card: {
    borderRadius: '14px',
    // maxWidth: 360,
    // minWidth: 320,
    // minHeight: 650,
    padding: theme.spacing(4, 4),
    margin: theme.spacing(2, 2, 2, 6),
    background: theme.palette.common.white,
    [theme.breakpoints.between('lg', 'xl')]: {
      width: 320,
      height: 550,
    },
    [theme.breakpoints.up('xl')]: {
      width: 350,
      height: 640,
    },
  },
  imageTalent: {
    width: '170px',
  },
  imageKonecta: {
    width: '400px',
    marginLeft: '380px',
    top: '475px',
  },
  titleForm: {
    fontWeight: 'normal',
    fontSize: 16,
    color: theme.palette.common.blue,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(2),
  },
  titleSession: {
    fontWeight: 600,
    fontSize: 24,
    color: theme.palette.common.blue,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(5),
  },
  sectionDivider: {
    background: theme.palette.common.pink,
    size: '5',
    margin: theme.spacing(1, 1, 1),
    borderBottomWidth: 4,
  },
  input: {
    border: `1px solid ${theme.palette.background.primary}`,
    borderRadius: 'px',
    background: theme.palette.background.default,
    [theme.breakpoints.down('md')]: {
      width: '210px',
    },
    [theme.breakpoints.up('md')]: {
      width: '300px',
    },
    marginTop: theme.spacing(1),
  },
  error: {
    color: theme.palette.common.red,
    margin: '5px',
    marginTop: theme.spacing(6),
  },
  forget: {
    fontWeight: 'normal',
    fontSize: 14,
    color: theme.palette.text.alert,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(2),
  },
  icon: {
    color: 'gray',
  },
  submit: {
    color: theme.palette.background.default,
    boxShadow: theme.shadows[1],
    fontWeight: '400',
    marginTop: theme.spacing(8),
    textTransform: 'capitalize',
    padding: '6px 20px',
    background: theme.palette.background.secondary,
    fontSize: 16,
    fontFamily: 'Raleway',
    '&:hover': {
      background: theme.palette.common.gray,
    },
  },
  modalFirstPassword: {
    borderRadius: '14px',
    position: 'absolute',
    width: 340,
    height: 220,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4, 4),
  },
  tilteModal: {
    fontWeight: 'normal',
    fontSize: 19,
    color: theme.palette.common.blue,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
  },
  btnModal: {
    color: theme.palette.background.default,
    boxShadow: theme.shadows[1],
    fontWeight: '400',
    marginTop: theme.spacing(2),
    textTransform: 'capitalize',
    padding: '6px 38px',
    background: theme.palette.background.secondary,
    fontSize: 16,
    fontFamily: 'Raleway',
    display: 'flex',
    justifyContent: 'center',
  },
  iconModal: {
    color: theme.palette.common.blue,
    marginTop: theme.spacing(4),
    width: 50,
  },
}));

function ForgotPassword() {
  const classes = useStyles();
  const [isForgotPassword, setIsForgotPassword] = useState(true);
  const [name, setName] = useState('');

  return (
    <Card className={classes.card} noValidate>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={1}
      >
        <img
          className={classes.imageTalent}
          alt="logo-talent"
          src={logoTalent}
        />
      </Grid>
      {isForgotPassword ? (
        <PasswordForget
          setIsForgotPassword={setIsForgotPassword}
          setName={setName}
        />
      ) : (
        <PasswordValidateCode name={name} />
      )}
    </Card>
  );
}

export default ForgotPassword;
